import styled from '@emotion/styled';

export const ConnectionOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 0;
    z-index: 1000;
    text-align: center;
    & > div {
        display: inline-block;
        text-align: left;
        padding: ${(p) => p.theme.size.medium};
        font-size: ${(p) => p.theme.fontSize.small};
        color: ${(p) => p.theme.color.white};
        text-align: center;
        background-color: ${(p) => p.theme.color.black};

        border: ${(p) => p.theme.border.thin};
        border-color: ${(p) => p.theme.color.gray2};
        border-top: none;
        border-bottom-left-radius: ${(p) => p.theme.borderRadius.medium};
        border-bottom-right-radius: ${(p) => p.theme.borderRadius.medium};
    }
`;

export const Circle = styled.div`
    display: inline-block;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin-right: 10px;
`;

export const RedCircle = styled(Circle)`
    background: ${(p) => p.theme.color.red};
`;
